import { useEffect, useState } from 'react';

function useWorkerJobStatus(fetchJobs) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const loadJobs = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchJobs();
        if (mounted) setJobs(Array.isArray(data) ? data.filter(Boolean) : []);
      } catch (requestError) {
        if (mounted) setError(requestError.message);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    loadJobs();
    return () => { mounted = false; };
  }, [fetchJobs]);

  return { jobs, loading, error, setJobs };
}

export default useWorkerJobStatus;
